import * as React from 'react';
import moment from 'moment';
import { IReportRow, PackDetailsInformationEvent } from '../../../../../Types';
import { IReportsRequestData } from '../Types';
import { EventHandlerProvider } from '../../../../../Services';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { HistoryRagIcon, HistoryUprcIcon, CopyText } from '../Components';

export class ReportGenerator {
    static truncatedText = (text: string, maxLength: number) => {
         return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
        }
    static checkIfSingleWord = (text: string) => { 
        return /^\S+$/.test(text);
    }
    static getReport = (elem: IReportRow, id: string, resources: any, onExpand: () => void): IReportsRequestData => {

        if (elem.isSinglePackResult) {
            var requestData: IReportsRequestData = {} as IReportsRequestData;
            elem.packs && elem.packs.length && elem.packs.map((el) => {
                requestData = {
                    id: id,
                    serialNumber: <span style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => { EventHandlerProvider.GetInstance().AddEvent(PackDetailsInformationEvent(resources, elem, el)); }}>{ReportGenerator.truncatedText(el.serialNumber, 10)}</span>,
                    // If the product name is a single world, we will need to truncate it, otherwise we can leave as it
                    productName: ReportGenerator.checkIfSingleWord(elem.additionalInfo.productName) && elem.additionalInfo.productName ? ReportGenerator.truncatedText(elem.additionalInfo.productName, 8) : elem.additionalInfo.productName,
                    expiryDate : el.expiryDate,
                    batchId: ReportGenerator.truncatedText(el.batchId, 8),
                    submissionTime: moment.utc(elem.additionalInfo.submitTime && new Date(elem.additionalInfo.submitTime)).format("L LT"),
                    action: elem.additionalInfo.action,
                    RAG: HistoryRagIcon.getRagSingle(el),
                    UPRC: el.uprc && <div style={{ display: "flex", justifyContent: "space-evenly" }}><HistoryUprcIcon uprc={el.uprc} /><CopyText copyTarget={el.uprc} resources={resources} /></div> || <div />
                };
            });

            return requestData;
        } else {
            var requestData: IReportsRequestData = {
                id: id,
                serialNumber: <span style={{ cursor: "pointer" }} onClick={() => { onExpand(); }}><FontAwesomeIcon className="mr-2" icon={faPlusCircle} />{elem.additionalInfo.action} ({elem.packs.length})</span>,
                productName: undefined,
                expiryDate : undefined,
                batchId: undefined,
                submissionTime: moment.utc(elem.additionalInfo.submitTime && new Date(elem.additionalInfo.submitTime)).format("L LT"),
                action: elem.additionalInfo.action,
                RAG: HistoryRagIcon.getRagMultiple(elem.packs),
                UPRC: <div />,
                packs: []
            };
            elem.packs && elem.packs.length && elem.packs.map((el) => {
                requestData.packs?.push({
                    serialNumber: <span style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => { EventHandlerProvider.GetInstance().AddEvent(PackDetailsInformationEvent(resources, elem, el)); }}>{ReportGenerator.truncatedText(el.serialNumber, 10)}</span>,
                    submissionTime: "",
                    action: "",
                    productName: ReportGenerator.checkIfSingleWord(el.productName)&& el.productName ? ReportGenerator.truncatedText(el.productName, 8) : el.productName,
                    expiryDate : el.expiryDate,
                    batchId: ReportGenerator.truncatedText(el.batchId, 6),
                    RAG: HistoryRagIcon.getRagSingle(el),
                    UPRC: el.uprc && <div style={{ display: "flex", justifyContent: "space-evenly" }}><HistoryUprcIcon uprc={el.uprc} /><CopyText copyTarget={el.uprc} resources={resources} /></div> || <div />
                });
            });
            return requestData;
        }
    };
}